import { FormProvider, UseFormReturn } from 'react-hook-form';

interface SVFormProps<T extends Record<string, any>> {
  children: React.ReactNode;
  methods: UseFormReturn<T>;
  onSubmit: (data: T) => void | Promise<void>;
}

export default function SVForm<T extends Record<string, any>>({
  children,
  methods,
  onSubmit,
}: SVFormProps<T>) {
  return (
    <FormProvider {...methods}>
      <form onSubmit={methods.handleSubmit(onSubmit)}>{children}</form>
    </FormProvider>
  );
}
